// extracted by mini-css-extract-plugin
export var activeDot = "_2f-c";
export var buttonContainer = "_2f-9";
export var channelButton = "_2f-a";
export var clickable = "_2f-d";
export var content = "_2f-0";
export var contentFull = "_2f-2";
export var contentThird = "_2f-1";
export var contentWrapper = "_2f-7";
export var description = "_2f-5";
export var heightShort = "_2f-f";
export var image = "_2f-3";
export var imageContainer = "_2f-4";
export var selectButton = "_2f-e";
export var spinnerContainer = "_2f-b";
export var titleContent = "_2f-8";
export var titleWrapper = "_2f-6";